module.exports = __webpack_public_path__ + "static/secondaryVideo-facc98dd65569eed98fd5881ac6fa12c.mp4";